(() => {
  if (window.akumaCollectionSpacingInitialized) return;
  window.akumaCollectionSpacingInitialized = true;
  const instances = new Map();

  function connect(component) {
    const slider = component.querySelector('.slider');
    const controls = component.querySelector('.slider-buttons');
    if (!slider || !controls) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!controls.getClientRects().length) return;
      const bounds = slider.getBoundingClientRect();
      let contentBottom = -Infinity;
      slider.querySelectorAll(':scope > .slider__slide').forEach((slide) => {
        const rect = slide.getBoundingClientRect();
        if (rect.right <= bounds.left + 1 || rect.left >= bounds.right - 1) return;
        // Measure real content, not the row height inherited from off-screen cards.
        const info = slide.querySelector('.card > .card__content > .card__information');
        if (!info) return;
        info.querySelectorAll('.price, .card__information-volume-pricing-note').forEach((element) => {
          const content = element.getBoundingClientRect();
          if (content.height && content.width) contentBottom = Math.max(contentBottom, content.bottom);
        });
      });
      if (!Number.isFinite(contentBottom)) return;
      const currentMargin = parseFloat(getComputedStyle(controls).marginTop) || 0;
      const naturalTop = controls.getBoundingClientRect().top - currentMargin;
      // 10px to the 44px buttons keeps the counter about 32px below the price.
      const margin = Math.round((contentBottom + 10 - naturalTop) * 100) / 100;
      if (Math.abs(currentMargin - margin) > 0.1) controls.style.marginTop = `${margin}px`;
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const observer = new ResizeObserver(schedule);
    const observeCards = () => {
      observer.disconnect();
      observer.observe(slider);
      slider.querySelectorAll('.card__information').forEach((info) => observer.observe(info));
      schedule();
    };
    const mutations = new MutationObserver(observeCards);
    mutations.observe(slider, { subtree: true, childList: true, characterData: true });
    slider.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
    observeCards();
    instances.set(component, () => {
      observer.disconnect();
      mutations.disconnect();
      cancelAnimationFrame(frame);
      slider.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    });
  }

  const refresh = () => {
    instances.forEach((disconnect, component) => {
      if (!component.isConnected) {
        disconnect();
        instances.delete(component);
      }
    });
    document.querySelectorAll('[data-akuma-compact-spacing]').forEach((component) => {
      if (!instances.has(component)) connect(component);
    });
  };
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  refresh();
})();
